(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    const closeMenuDetails = (details) => {
    if (!(details instanceof HTMLDetailsElement)) return;
    details.removeAttribute('open');
    details.querySelectorAll('details[open]').forEach((nested) => nested.removeAttribute('open'));
  };

  const setupDesktopAccordionMenu = () => {
    document.querySelectorAll('.rtl-desktop-nav').forEach((nav) => {
      if (nav.dataset.autoCloseBound === 'true') return;
      nav.dataset.autoCloseBound = 'true';

      nav.querySelectorAll('.rtl-desktop-nav__details').forEach((topDetails) => {
        topDetails.addEventListener('toggle', () => {
          if (!topDetails.open) return;
          nav.querySelectorAll('.rtl-desktop-nav__details[open]').forEach((otherDetails) => {
            if (otherDetails !== topDetails) closeMenuDetails(otherDetails);
          });
        });
      });

      nav.querySelectorAll('.rtl-desktop-nav__nested-details').forEach((nestedDetails) => {
        nestedDetails.addEventListener('toggle', () => {
          if (!nestedDetails.open) return;
          const dropdown = nestedDetails.closest('.rtl-desktop-nav__dropdown');
          dropdown?.querySelectorAll('.rtl-desktop-nav__nested-details[open]').forEach((otherDetails) => {
            if (otherDetails !== nestedDetails) closeMenuDetails(otherDetails);
          });
        });
      });

      nav.querySelectorAll('.rtl-desktop-nav__item').forEach((item) => {
        const topDetails = item.querySelector(':scope > .rtl-desktop-nav__details');
        if (!(topDetails instanceof HTMLDetailsElement)) return;
        item.addEventListener('pointerleave', () => closeMenuDetails(topDetails));
      });

      document.addEventListener('pointerdown', (event) => {
        if (!(event.target instanceof Node) || nav.contains(event.target)) return;
        nav.querySelectorAll('.rtl-desktop-nav__details[open]').forEach(closeMenuDetails);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        nav.querySelectorAll('.rtl-desktop-nav__details[open]').forEach(closeMenuDetails);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDesktopAccordionMenu, { once: true });
  } else {
    setupDesktopAccordionMenu();
  }
  } catch(e) { console.error(e); }
})();

})();
